import styles from '../ChallengeDetail.module.scss';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';
import image161 from './images/16-1.jpg';
import image181 from './images/18-1.jpg';
import image201 from './images/20-1.jpg';

export const CompleteEpicCollectionDescription = () => {
    return (
        <div className={styles.description}>
            <p>
                <div>
                    Потратьте 12 билетов на участие в розыгрышах за фиолетовые билеты, чтобы собрать эпическую коллекцию
                </div>
                <div>
                    Посмотреть коллекцию можно в разделе <b>Активы</b>
                </div>
                <ChallengeDetailHelpImage image={image161} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Подраздел <b>«Коллекции»</b>
                </div>
                <ChallengeDetailHelpImage image={image181} helpText='Это картинка. Ищите вкладку в разделе «Активы».' />
            </p>
            <p>
                <div>
                    Далее ищите
                </div>
                <ChallengeDetailHelpImage image={image201} helpText='Это картинка. Ищите эпическую коллекцуию в подразделе «Коллекции».' />
            </p>
        </div>
    );
}